import 'moment/locale/ja'
import './src/styles/global.css'
import './src/styles/index.scss'
import '@fontsource/noto-sans-jp'
import '@fontsource/roboto'
import React from 'react'
import { navigate } from 'gatsby'
import { ApolloProvider } from '@apollo/client'
import { Layouts } from './src/components/layouts'
import { Auth0Provider } from './src/auth/Auth0-Provider'
import config from './src/config'
import { ConfigProvider } from 'antd'
import { client } from './src/apollo/client'

const onRedirectCallback = (appState) => {
  navigate(appState?.returnTo || '/', { replace: true })
}

export const wrapRootElement = ({ element }) => {
  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      redirectUri={config.auth0.callback}
      audience={config.auth0.audience}
      responseType="token id_token"
      scope="openid profile email"
      cacheLocation="localstorage"
      useCookiesForTransactions={true}
      useFormData={true}
      onRedirectCallback={onRedirectCallback}
    >
      <ApolloProvider client={client}>{element}</ApolloProvider>
    </Auth0Provider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#7BC24A',
          fontFamily: `'Noto Sans JP', Roboto`,
        },
      }}
    >
      <Layouts {...props}>{element}</Layouts>
    </ConfigProvider>
  )
}
